export default class Assessment{
    constructor(title, description, type, isRandom, isSortingByLevel) {
        this.title = title;
        this.description = description;
        this.type = type;
        this.isRandom = isRandom;
        this.isSortingByLevel = isSortingByLevel;
    }
}